export default __webpack_public_path__ + "static/media/typewriter.218fcab5.svg";